import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;
const Destinationcountry = {
  getList: async () => {
    const response = await apiService.get("/ourservices");

    return response.data;
  },
  getbyId: async (id) => {
    const response = await apiService.get(`/ourservices/${id}`);
    return response.data;
  },
  getbySlug: async (id) => {
    const response = await apiService.get(
      `/ourservices/slug?slug=${id}`
    );
    return response.data;
  },
};

export default Destinationcountry;
